import { useSyncExternalStore } from 'react';

export type Theme = 'light' | 'dark' | 'system';
export type Density = 'comfortable' | 'compact';
export interface Preferences { theme: Theme; density: Density; collapsed: boolean }
const key = 'dexa:preferences:v1';
const listeners = new Set<() => void>();
function load(): Preferences {
    try {
        const data = JSON.parse(localStorage.getItem(key) || '{}');
        return {
            theme: ['light', 'dark', 'system'].includes(data.theme) ? data.theme : 'light',
            density: data.density === 'compact' ? 'compact' : 'comfortable',
            collapsed: data.collapsed === true,
        };
    } catch { return { theme: 'light', density: 'comfortable', collapsed: false }; }
}
let preferences = load();
function subscribe(callback: () => void) { listeners.add(callback); return () => { listeners.delete(callback); }; }
export function setPreferences(update: Partial<Preferences>) {
    preferences = { ...preferences, ...update };
    try { localStorage.setItem(key, JSON.stringify(preferences)); } catch { /* Browsing storage may be disabled. */ }
    listeners.forEach(callback => callback());
}
export function usePreferences() { return useSyncExternalStore(subscribe, () => preferences); }
